import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, Teleport as _Teleport, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/question.svg'
import _imports_1 from '@/assets/printing-assets/help-step-1.png'
import _imports_2 from '@/assets/printing-assets/help-step-2.png'
import _imports_3 from '@/assets/printing-assets/help-step-3.png'
import _imports_4 from '@/assets/printing-assets/help-step-4.png'


_pushScopeId("data-v-41e9f264")
const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("div", { id: "title" }, [
    /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }),
    /*#__PURE__*/_createElementVNode("span", null, "Printing Help")
  ]),
  /*#__PURE__*/_createElementVNode("p", null, "Please check the boxes below to indicate that you've completed each step")
], -1)
const _hoisted_2 = { class: "modal-content" }
const _hoisted_3 = { id: "help-steps" }
const _hoisted_4 = { class: "help-step" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "help-number" }, [
  /*#__PURE__*/_createElementVNode("span", null, "1")
], -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1)
const _hoisted_7 = { class: "text-wrap" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h2", null, "Paper Size", -1)
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Select the correct paper size of ")
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" for your label sheet. ")
const _hoisted_11 = {
  key: 0,
  class: "step-check"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { for: "size" }, "I've set my paper size", -1)
const _hoisted_13 = { class: "help-step" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "help-number" }, [
  /*#__PURE__*/_createElementVNode("span", null, "2")
], -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("img", { src: _imports_2 }, null, -1)
const _hoisted_16 = { class: "text-wrap" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("h2", null, "Scale", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" Set your scale to "),
  /*#__PURE__*/_createElementVNode("strong", null, "Actual Size"),
  /*#__PURE__*/_createTextVNode(" or "),
  /*#__PURE__*/_createElementVNode("strong", null, "100%"),
  /*#__PURE__*/_createTextVNode(". Do not shrink to fit your page. ")
], -1)
const _hoisted_19 = {
  key: 0,
  class: "step-check"
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", { for: "scale" }, "I've set the proper scale", -1)
const _hoisted_21 = { class: "help-step" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "help-number" }, [
  /*#__PURE__*/_createElementVNode("span", null, "3")
], -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("img", { src: _imports_3 }, null, -1)
const _hoisted_24 = { class: "text-wrap" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("h2", null, "Paper Weight", -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" Set your "),
  /*#__PURE__*/_createElementVNode("strong", null, "Paper"),
  /*#__PURE__*/_createTextVNode(" or "),
  /*#__PURE__*/_createElementVNode("strong", null, "Media Type"),
  /*#__PURE__*/_createTextVNode(" to "),
  /*#__PURE__*/_createElementVNode("strong", null, "Labels"),
  /*#__PURE__*/_createTextVNode(" or a similar setting such as "),
  /*#__PURE__*/_createElementVNode("strong", null, "Heavyweight Paper"),
  /*#__PURE__*/_createTextVNode(". ")
], -1)
const _hoisted_27 = {
  key: 0,
  class: "step-check"
}
const _hoisted_28 = /*#__PURE__*/_createElementVNode("label", { for: "weight" }, "I've set my paper weight", -1)
const _hoisted_29 = { class: "help-step" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", { class: "help-number" }, [
  /*#__PURE__*/_createElementVNode("span", null, "4")
], -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("img", { src: _imports_4 }, null, -1)
const _hoisted_32 = { class: "text-wrap" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("h2", null, "Labels Loaded", -1)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" Load your labels so that the "),
  /*#__PURE__*/_createElementVNode("a", null, "registration marks"),
  /*#__PURE__*/_createTextVNode(" print on the "),
  /*#__PURE__*/_createElementVNode("strong", null, "top right"),
  /*#__PURE__*/_createTextVNode(" of your sheet. ")
], -1)
const _hoisted_35 = {
  key: 0,
  class: "step-check"
}
const _hoisted_36 = /*#__PURE__*/_createElementVNode("label", { for: "loaded" }, "I've loaded my labels", -1)
const _hoisted_37 = {
  key: 0,
  id: "step-checks"
}
const _hoisted_38 = { class: "step-check" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("label", { for: "size" }, "I've set my paper size", -1)
const _hoisted_40 = { class: "step-check" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("label", { for: "scale" }, "I've set the proper scale", -1)
const _hoisted_42 = { class: "step-check" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("label", { for: "weight" }, "I've set my paper weight", -1)
const _hoisted_44 = { class: "step-check" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("label", { for: "loaded" }, "I've loaded my labels", -1)
const _hoisted_46 = { id: "help-btns" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("div", null, "Did these tips help your labels print correctly?", -1)
const _hoisted_48 = ["disabled"]
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CloseSVG = _resolveComponent("CloseSVG")!

  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createElementVNode("div", {
      class: _normalizeClass([_ctx.fadeTransition, "modal"])
    }, [
      _createElementVNode("div", {
        class: _normalizeClass([_ctx.bounceTransition, "modal-body"])
      }, [
        _createElementVNode("div", {
          class: "close-svg",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
        }, [
          _createVNode(_component_CloseSVG, {
            propId: 'print-close',
            fillColor: '#f7f9fc'
          })
        ]),
        _hoisted_1,
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _hoisted_6,
              _createElementVNode("div", _hoisted_7, [
                _hoisted_8,
                _createElementVNode("p", null, [
                  _hoisted_9,
                  _createElementVNode("strong", null, _toDisplayString(_ctx.currentLabel.sheet_size_title), 1),
                  _hoisted_10
                ]),
                (_ctx.clientDimensions.width <= 767)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                      _createElementVNode("input", {
                        onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleChange('size'))),
                        ref: "size",
                        id: "size",
                        type: "checkbox"
                      }, null, 544),
                      _hoisted_12
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _hoisted_14,
              _hoisted_15,
              _createElementVNode("div", _hoisted_16, [
                _hoisted_17,
                _hoisted_18,
                (_ctx.clientDimensions.width <= 767)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                      _createElementVNode("input", {
                        onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleChange('scale'))),
                        ref: "scale",
                        id: "scale",
                        type: "checkbox"
                      }, null, 544),
                      _hoisted_20
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_21, [
              _hoisted_22,
              _hoisted_23,
              _createElementVNode("div", _hoisted_24, [
                _hoisted_25,
                _hoisted_26,
                (_ctx.clientDimensions.width <= 767)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                      _createElementVNode("input", {
                        onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.handleChange('weight'))),
                        ref: "weight",
                        id: "weight",
                        type: "checkbox"
                      }, null, 544),
                      _hoisted_28
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_29, [
              _hoisted_30,
              _hoisted_31,
              _createElementVNode("div", _hoisted_32, [
                _hoisted_33,
                _hoisted_34,
                (_ctx.clientDimensions.width <= 767)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                      _createElementVNode("input", {
                        onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.handleChange('loaded'))),
                        ref: "loaded",
                        id: "loaded",
                        type: "checkbox"
                      }, null, 544),
                      _hoisted_36
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          (_ctx.clientDimensions.width > 767)
            ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                _createElementVNode("div", _hoisted_38, [
                  _createElementVNode("input", {
                    onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.handleChange('size'))),
                    ref: "size",
                    id: "size",
                    type: "checkbox"
                  }, null, 544),
                  _hoisted_39
                ]),
                _createElementVNode("div", _hoisted_40, [
                  _createElementVNode("input", {
                    onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.handleChange('scale'))),
                    ref: "scale",
                    id: "scale",
                    type: "checkbox"
                  }, null, 544),
                  _hoisted_41
                ]),
                _createElementVNode("div", _hoisted_42, [
                  _createElementVNode("input", {
                    onChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.handleChange('weight'))),
                    ref: "weight",
                    id: "weight",
                    type: "checkbox"
                  }, null, 544),
                  _hoisted_43
                ]),
                _createElementVNode("div", _hoisted_44, [
                  _createElementVNode("input", {
                    onChange: _cache[8] || (_cache[8] = ($event: any) => (_ctx.handleChange('loaded'))),
                    ref: "loaded",
                    id: "loaded",
                    type: "checkbox"
                  }, null, 544),
                  _hoisted_45
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_46, [
          _hoisted_47,
          _createElementVNode("button", {
            onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
          }, "Yes, my problem is fixed"),
          _createElementVNode("button", {
            disabled: !_ctx.allStepsChecked,
            onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.openPrintingIssues && _ctx.openPrintingIssues(...args)))
          }, " No, I need more help ", 8, _hoisted_48)
        ])
      ], 2)
    ], 2)
  ]))
}